var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 147.877,
    height: 148,
    viewBox: "0 0 147.877 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "loader",
    transform: "translate(-100.751 -200.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3379",
    "data-name": "Path 3379",
    d: "M.013.542c14.648-3.388,28.567,9.522,28.351,27.27C11.986,27.163-.467,16.992.013.542",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 204.91, 229.455)",
    fill: "#005440",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3380",
    "data-name": "Path 3380",
    d: "M.013,27.27C14.661,30.657,28.581,17.747,28.364,0,11.986.649-.467,10.82.013,27.27",
    transform: "matrix(-0.996, 0.087, -0.087, -0.996, 157.504, 242.542)",
    fill: "#04ab83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3381",
    "data-name": "Path 3381",
    d: "M.013,27.27C14.661,30.657,28.581,17.747,28.364,0,11.986.649-.467,10.82.013,27.27",
    transform: "matrix(-0.766, -0.643, 0.643, -0.766, 186.368, 240.43)",
    fill: "#238e74",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3382",
    "data-name": "Path 3382",
    d: "M.013,27.27C14.661,30.657,28.581,17.747,28.364,0,11.986.649-.467,10.82.013,27.27",
    transform: "matrix(0.602, -0.799, 0.799, 0.602, 209.345, 287.882)",
    fill: "#238e74",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3383",
    "data-name": "Path 3383",
    d: "M.013,27.27C14.661,30.657,28.581,17.747,28.364,0,11.986.649-.467,10.82.013,27.27",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 191.029, 307.092)",
    fill: "#005440",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3384",
    "data-name": "Path 3384",
    d: "M.013,27.27C14.661,30.657,28.581,17.747,28.364,0,11.986.649-.467,10.82.013,27.27",
    transform: "translate(162.022 309.512) rotate(38)",
    fill: "#04ab83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3385",
    "data-name": "Path 3385",
    d: "M.013,27.27C14.661,30.657,28.581,17.747,28.364,0,11.986.649-.467,10.82.013,27.27",
    transform: "translate(142.412 290.099) rotate(82)",
    fill: "#238e74",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3386",
    "data-name": "Path 3386",
    d: "M.013,27.27C14.661,30.657,28.581,17.747,28.364,0,11.986.649-.467,10.82.013,27.27",
    transform: "matrix(-0.602, 0.799, -0.799, -0.602, 140.034, 262.269)",
    fill: "#005440",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.0594358f31c4f4049c3667c6837ee8b2.svg";
export { ForwardRef as ReactComponent };